import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { cache } from '@/util';
@Component({
  components: {
  },
})
export default class ProfilePhoto extends Vue {
  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //
  avatar = {
    url: '',
    loading: false,
  };

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M T E H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  getImage(email?: string) {
    if (email && email.indexOf('/') == -1) {
      this.avatar.loading = true;
      cache.avatar.get(email).then((url: string) => {
        this.avatar.url = url;
        this.avatar.loading = false;
      });
    }
  }

  error(e: Event) {
    var elem = e.srcElement as HTMLImageElement;
    elem.src = '/cm/gres/v1/img/ghost_loading.png';
  }

  errorGhost(e: Event) {
    var elem = e.srcElement as HTMLImageElement;
    elem.src = '/cm/gres/faux/images/ghost.png';
  }
}
